import React, { useEffect } from 'react';
import { compose, withState } from 'recompose';
import { withRouter } from 'react-router';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, Checkbox } from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';

const styles = {
  dialogContent: {
    maxWidth: '700px',
    fontWeight: 400,
    fontSize: '16px',
    color: '#000000',
    lineHeight: '32px'
  },
  checkBox: {
    padding: '5px 16px 0 0'
  },
  checkLine: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '16px'
  }
};

const enhance = compose(
  withState('policy1', 'setPolicy1', false),
  withState('policy2', 'setPolicy2', false),
  withState('policy3', 'setPolicy3', false)
);
const useStyles = makeStyles({
  paperWidthSm: {
    maxWidth: 325
  }
});

const Main = enhance(
  ({
    classes,
    openConfirmGochiKidFlag,
    updateOpenConfirmGochiKidFlag,
    okAction,
    isSmall,
    policy1,
    setPolicy1,
    policy2,
    setPolicy2,
    policy3,
    setPolicy3
  }) => {
    useEffect(() => {
      setPolicy1(false);
      setPolicy2(false);
      setPolicy3(false);
    }, [openConfirmGochiKidFlag]);

    const cancelAction = () => {
      updateOpenConfirmGochiKidFlag(false);
    };
    const classesD = useStyles();
    return (
      <Dialog
        open={openConfirmGochiKidFlag}
        onClose={() => {
          updateOpenConfirmGochiKidFlag(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classesD.paperWidthSm
        }}
      >
        <DialogContent style={{ padding: '60px 70px' }}>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.dialogContent}
          >
            こどもごちめしサービスは、個人や企業からの寄付によって運営しています。
            <br />
            「こどもごちめし」を利用したいお客様が利用できない場合、以下をご確認ください。
            <div>
              <div className={classes.checkLine} style={{ marginTop: '32px' }}>
                <Checkbox
                  color="primary"
                  className={classes.checkBox}
                  checked={policy1}
                  onChange={event => {
                    setPolicy1(event.target.checked);
                  }}
                />
                寄付された方への報告のため、利用者は利用後にコメントを投稿しないと次回以降ご利用いただけません。
              </div>
              <div className={classes.checkLine}>
                <Checkbox
                  color="primary"
                  className={classes.checkBox}
                  checked={policy2}
                  onChange={event => {
                    setPolicy2(event.target.checked);
                  }}
                />
                自店の食数の残数が0の場合、こどもごちめしが利用できる店舗一覧に表示されなくなり、利用者は貴店をご利用いただけません。
              </div>
              <div className={classes.checkLine}>
                <Checkbox
                  color="primary"
                  className={classes.checkBox}
                  checked={policy3}
                  onChange={event => {
                    setPolicy3(event.target.checked);
                  }}
                />
                利用者がこどもごちめしを利用できない場合、「コメントを投稿しているか」「自店の食数の残数があるか」をご確認ください。
              </div>
            </div>
          </DialogContentText>
          <DialogActions style={{ justifyContent: 'flex-start' }}>
            <CancelButton onClickAction={cancelAction} color="default" />
            <Button
              color="primary"
              onClick={okAction}
              disabled={!(policy1 && policy2 && policy3)}
            >
              OK
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
